import { render, staticRenderFns } from "./ProfileListTab.vue?vue&type=template&id=a2f1f35a&scoped=true&"
import script from "./ProfileListTab.vue?vue&type=script&lang=js&"
export * from "./ProfileListTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2f1f35a",
  null
  
)

export default component.exports